import { styled } from 'linaria/lib/react';

import { BREAKPOINTS } from '../../styles/constants';
import { PULSE_ANIMATION } from '../CardDetails/styled';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

// Overlay removed; handled by HeroBackgroundProvider now

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 32px 24px 16px;
  width: 100%;
  max-width: 390px;
  box-sizing: border-box;

  & > span {
    font-size: 22px;
    line-height: 130%;
  }

  @media screen and (min-width: ${BREAKPOINTS.xs}px) {
    max-width: 342px;
    padding: 32px 0 16px;
    margin-bottom: 10px;
  }
`;

export const StyledSliderContainer = styled.div`
  padding: 0 0 32px;
  max-width: 342px;
  width: 100%;

  .swiper-slide {
    max-width: 342px;
  }

  @media screen and (max-width: 370px) {
    width: calc(100% - 48px);
    margin: 0 auto;
  }
`;

export const StyledSlide = styled.div<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  max-width: 342px;

  > div {
    flex: 1 1;
    width: 100%;
  }

  ${PULSE_ANIMATION} {
    animation-play-state: ${({ isActive }) => (isActive ? 'running' : 'paused')};
  }
`;

export const StyledAlertWrap = styled.div`
  margin-bottom: 24px;
  max-width: 366px;
  width: 100%;
`;
